import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { reviewTypes } from 'constants/Profiles';
import { styled } from '@mui/material/styles';

import ReviewCard from './ReviewCard';

const StyledHr = styled('hr')(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  border: 'none',
  height: 1,
  margin: 0,
  marginBottom: 20,
}));

const ReviewsWidgetSection = ({ profile, type }) => {
  const { feedback } = profile;
  const reviews = feedback || [];

  const reviewsToRender =
    type !== reviewTypes.compact ? reviews : reviews.filter((review) => review.text.length > 0);

  return (
    <Box sx={{ marginBottom: 5 }}>
      {reviewsToRender.map((review) => (
        <Box key={review.id}>
          <StyledHr />
          <ReviewCard review={review} profile={profile} sx={{ marginBottom: '20px' }} />
        </Box>
      ))}
    </Box>
  );
};

ReviewsWidgetSection.propTypes = {
  profile: PropTypes.shape({}).isRequired,
  originalQuery: PropTypes.shape({}),
  type: PropTypes.oneOf(Object.values(reviewTypes)),
};

ReviewsWidgetSection.defaultProps = {
  type: reviewTypes.default,
  originalQuery: {},
};

export default ReviewsWidgetSection;
